import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ReportTargetType } from '@saesak/shared';
import { apiData } from './api';

/** 안전 도구 (§5.30) — 신고 대상과 차단 목록 훅. 화면 컴포넌트는 components/SafetyActions.tsx */

export interface ReportTarget {
  type: ReportTargetType;
  id: string;
}

export interface BlockedUser {
  userId: string;
  name: string;
  createdAt: string;
}

/** 내 차단 목록 — 여러 화면이 같은 쿼리를 공유한다 */
export function useBlocks() {
  return useQuery({
    queryKey: ['safety', 'blocks'],
    queryFn: () => apiData<BlockedUser[]>('/safety/blocks'),
    staleTime: 60_000,
  });
}

export function useBlockMutations() {
  const queryClient = useQueryClient();
  const refresh = () => {
    void queryClient.invalidateQueries({ queryKey: ['safety'] });
    // 차단은 쪽지·댓글·가정 소식 목록에 바로 반영된다
    void queryClient.invalidateQueries({ queryKey: ['messages'] });
    void queryClient.invalidateQueries({ queryKey: ['daily-notes'] });
    void queryClient.invalidateQueries({ queryKey: ['home-messages'] });
  };
  const block = useMutation({
    mutationFn: (userId: string) => apiData('/safety/blocks', { method: 'POST', body: { userId } }),
    onSuccess: refresh,
  });
  const unblock = useMutation({
    mutationFn: (userId: string) => apiData(`/safety/blocks/${userId}`, { method: 'DELETE' }),
    onSuccess: refresh,
  });
  return { block, unblock };
}
